/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{LayerViewPerformanceInfo as e}from"./support/LayerViewPerformanceInfo.js";class t extends e{constructor(e,t,s,r,o,h,c){super(e,0,0,0,t),this.nodesCached=s,this.vboMB=r,this.textureMB=o,this.vboMBCached=h,this.textureMBCached=c}}export{t as IntegratedMesh3DTilesViewPerformanceInfo};
